export default {
  messages: state => state.messages,
  isTyping: state => state.isTyping,
  chatHistory: state => state.chatHistory,
  directMessageCount: state => state.directMessageCount,
  cleanMessage: state => state.cleanMessage,
  files: state => state.files,
  channels: state => state.channels,
  token: state => state.token
}



// WEBPACK FOOTER //
// ./src/store/modules/chat/getters.js